import React from 'react';
import styles from './index.module.scss';

export const Loader = () => (
  <div className={styles.container}>
    <div className={styles.loader}>
      <div />
      <div />
      <div />
    </div>
  </div>
);
